import { render } from "./SecretaryPiv.vue?vue&type=template&id=2c1bebb2&scoped=true"
import script from "./SecretaryPiv.vue?vue&type=script&lang=js"
export * from "./SecretaryPiv.vue?vue&type=script&lang=js"

import "./SecretaryPiv.vue?vue&type=style&index=0&id=2c1bebb2&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1bebb2"]])

export default __exports__